import { Store } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { OnboardingStepCard } from '@/components/onboarding/OnboardingStepCard';

export const GoogleBusinessProfile = ({
	isActive,
	isCompleted,
	businessDetailsCompleted,
	gbpLoading,
	pollingForGBPConnection,
	gbpError,
	currentShop,
	onConnect
}) => {
	return (
		<OnboardingStepCard
			icon={Store}
			title="Connect Google Business Profile"
			subtitle="Sync your in-store stock to Google Search and Maps."
			isCompleted={isCompleted}
			isActive={isActive}
		>
			{!isCompleted ? (
				<div className="space-y-4">
					{pollingForGBPConnection && (
						<div className="rounded-2xl border border-info/40 bg-info-soft px-4 py-3 text-sm text-info-soft-foreground">
							<p className="font-semibold">Verifying Google Business Profile connection…</p>
							<p className="mt-1 text-xs opacity-80">
								This should only take a moment. We&apos;re confirming your connection.
							</p>
						</div>
					)}

					{gbpError && (
						<div className="rounded-2xl border border-destructive/40 bg-destructive/10 px-4 py-3 text-sm text-destructive">
							{gbpError}
						</div>
					)}

					<Button
						className="rounded-full px-6"
						onClick={onConnect}
						disabled={!businessDetailsCompleted || gbpLoading || pollingForGBPConnection}
					>
						{gbpLoading || pollingForGBPConnection ? 'Connecting…' : 'Connect Google Business Profile'}
					</Button>
				</div>
			) : (
				<dl className="grid grid-cols-1 gap-1 rounded-xl bg-muted/50 px-4 py-3 text-sm sm:grid-cols-[120px_1fr]">
					<dt className="text-muted-foreground">Connected as</dt>
					<dd className="font-medium text-foreground">{currentShop?.gmbConnection?.email || 'N/A'}</dd>
					<dt className="text-muted-foreground">Location</dt>
					<dd className="font-medium text-foreground">{currentShop?.name || 'N/A'}</dd>
				</dl>
			)}
		</OnboardingStepCard>
	);
};
